
import { call, put, select } from 'redux-saga/effects'
import request from '@src/utility/request'
import { 
    addProductInfoSuccess,
    addProductInfoFail,
    updateProductInfoSuccess,
    updateProductInfoFail,
    deleteProductInfoSuccess,
    deleteProductInfoFail
} from '../../actions/product'
import { loadStepsData } from '../../actions/steps'
import { 
    selectAddInfoUrl,
    selectUpdateInfoUrl,
    selectDeleteInfoUrl
} from '../../selectors/product'
import { selectBaseUrl, selectLocale } from '../../selectors/config'
import { selectToken } from '../../selectors/auth'
import { toast, Slide } from 'react-toastify'
import ToastContent from '../../../components/Toast'

// worker Saga: will be fired on DELETE_PRODUCT_ROUTE_INFO action
export function* deleteInfo(params) {
    const { id, infoType, identifier } = params
   
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = yield select(selectDeleteInfoUrl(infoType))
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
     
    const requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
        
        if (res.data) {
            yield put(deleteProductInfoSuccess(id, infoType))
            yield put(loadStepsData(identifier))
        } else yield put(deleteProductInfoFail(id, infoType, res.data))
        
      
    } catch (e) {
       yield put(deleteProductInfoFail(id, infoType, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on ADD_PRODUCT_ROUTE_INFO action
export function* addInfo(params) {
    const { infoType, data, identifier, callback } = params
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = yield select(selectAddInfoUrl(infoType))
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }
    
    /*eslint-disable */
    let formdata = new FormData()
    for (let k in data) {
       
       
        if (data[k].toString.call(data[k]).slice(8, -1) === 'FileList'){
            console.log(k)
            if ( data[k].length > 0) formdata.append(k, data[k][0], data[k][0].name)
        } 
        else if(data[k].length && data[k].map){
            data[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if(data[k]) formdata.append(k, data[k])
    
    }
    /*eslint-enable */


    const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/`, requestOptions)
        
        if (res.data?.id) {
            
            yield put(addProductInfoSuccess(infoType, res.data))
            yield put(loadStepsData(identifier))
            yield callback()
            
        } else yield put(addProductInfoFail(infoType, res.data))
        
      
    } catch (e) {
       yield put(addProductInfoFail(infoType, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}

// worker Saga: will be fired on UPDATE_PRODUCT_ROUTE_INFO action
export function* updateInfo(params) {
    const { id, infoType, item, identifier, callback } = params
   
    const requestURL = yield select(selectBaseUrl())
    const locale = yield select(selectLocale())
    const dataURL = yield select(selectUpdateInfoUrl(infoType))
    const token = yield select(selectToken())
    
    const myHeaders = { 
        Accept: "application/json",
        "Content-Type":"multipart/form-data",
        "Accept-Language":locale,
        "User-Agent": "AFTS Web App",
        Authorization: `Token ${token}`,
        Origin : "*"
    }

    /*eslint-disable */
    let formdata = new FormData()
    for (let k in item) {
       
       
        if (item[k].toString.call(item[k]).slice(8, -1) === 'FileList'){
            console.log(k)
            if ( item[k].length > 0) formdata.append(k, item[k][0], item[k][0].name)
        } 
        else if(item[k].length && item[k].map){
            item[k].map((item) => {
                formdata.append(k, item)
            })
        }
        else if( item[k]!== null) formdata.append(k, item[k])
    
    }
    /*eslint-enable */

    const requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        data:formdata,
        mode:'cors',
        credentials:'include'
    }

    try {
        
        const res = yield call(request, `${requestURL}${dataURL}/${id}`, requestOptions)
        
        if (res.data?.id) {
            yield put(updateProductInfoSuccess(id, infoType, res.data))
            yield put(loadStepsData(identifier))
            yield callback()
        } else yield put(updateProductInfoFail(id, infoType, res.data))
        
      
    } catch (e) {
       yield put(updateProductInfoFail(id, infoType, [{message: e.message}]))

       toast.error(
        <ToastContent type="error" title="Ooops!" body={e.message} />,
        { transition: Slide, hideProgressBar: true }
        )
    }
}